/* import config from 'c'; */
import { authHeader } from "../../../helpers/authHeader";
import { handleResponse } from "../../../helpers/handleresponse";

export const languageService = {
  getAllCodes,
  getAllCodesByEvent
};

async function getAllCodesByEvent(eventId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" }),
  };

  return fetch(`./api/language/${eventId}`, requestOptions)
    .then(handleResponse)
    .then(languagesCodes => {
      return languagesCodes;
    });
}

async function getAllCodes() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return fetch(`./api/language/`, requestOptions)
    .then(handleResponse)
    .then(languagesCodes => {
      return languagesCodes;
    });
}




